import { render, staticRenderFns } from "./ProjectGroupList.vue?vue&type=template&id=4ec7bcf4&scoped=true&"
import script from "./ProjectGroupList.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectGroupList.vue?vue&type=style&index=0&id=4ec7bcf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7bcf4",
  null
  
)

export default component.exports